// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/theme/css/dashboard.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-body {
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  cursor: pointer;
  border-left: 5px solid var(--dynamic-color);
  border-right: 5px solid var(--dynamic-color);
  color: black;
}

.card-body .text-muted {
  color: black;
}

.card-body:hover {
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  cursor: pointer;
  background-color: white;
  color: black;
}

.card-container {
  flex: 0 0 20%;
  max-width: 20%;
}

@media (max-width: 992px) {
  .card-container {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 576px) {
  .card-container {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.row.g-2 {
  display: flex;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/app/home/dashboard-balance/dashboard-balance.component.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,yCAAA;EACA,+BAAA;EACA,eAAA;EACA,2CAAA;EACA,4CAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,mBAAA;EACA,yCAAA;EACA,+BAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;AAAF;;AAGA;EACE;IACE,aAAA;IACA,cAAA;EAAF;AACF;AAGA;EACE;IACE,cAAA;IACA,eAAA;EADF;AACF;AAGA;EACE,aAAA;EACA,eAAA;AADF","sourcesContent":["@import '../../../assets/theme/css/dashboard.css';\n\n.card-body {\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease;\n  cursor: pointer;\n  border-left: 5px solid var(--dynamic-color);\n  border-right: 5px solid var(--dynamic-color);\n  color: black;\n}\n\n.card-body .text-muted {\n  color: black;\n}\n\n.card-body:hover {\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease;\n  cursor: pointer;\n  background-color: white;\n  color: black;\n}\n\n.card-container {\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n@media (max-width: 992px) {\n  .card-container {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n\n@media (max-width: 576px) {\n  .card-container {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n.row.g-2 {\n  display: flex;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
